import {Link, Redirect} from "react-router-dom";
import React, {useEffect, useState} from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import MyAppBar from "./miscellaneous/MyAppBar";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Footer from "./miscellaneous/Footer";
import {useStyles, urlapi, NEED_LOGIN} from "./miscellaneous/constants";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {useCookies} from "react-cookie";
import Load from "./miscellaneous/Load";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";


export default function SelectCompetition() {

    const [cookies, setCookie, removeCookie] = useCookies(['analyzer']);
    const classes = useStyles();
    const [competitions, setCompetitions] = useState([]);
    const [selected, setSelected] = useState(null)
    async function loadCompetitions() {
        if(NEED_LOGIN && !cookies.analyzer)
            return;
        const cmps = (await axios.get(urlapi + "/competitions")).data;
        setCompetitions(cmps);
    }

    useEffect(() => {
        if(NEED_LOGIN)
            axios.defaults.headers.common["Authorization"] = (cookies.analyzer ? "Bearer " + cookies.analyzer.token : null)
        loadCompetitions()
    }, [cookies.analyzer]);


    function changeCompetition(e) {
        setSelected(e.target.value)
    }
    //if(!cookies.analyzer)
    //    return <Redirect to={"/login"} />

    if(selected != null)
        return <Redirect to={"/competitions/"+selected} />

    if(competitions.length === 0)
        return (
            <Load>
            </Load>
        )

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <MyAppBar active={"home"}/>
            <main >
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="md" className={classes.container}
                           style={{"minHeight": "95vh",width:'70%',
                               display: 'flex',
                               justifyContent: 'space-between', flexDirection: 'column'}}>
                    <Box fontWeight="fontWeightLight" style={{

                    }}>
                        <Typography>
                            <h1>Scanning the Results of the 2022 XCSP3 Competition</h1>
                            <div>
                                The fourth international XCSP3 constraint solver competition is organized in 2022 to improve our knowledge about
                                components (e.g., filtering algorithms, heuristics, search strategies, encoding/reformulation techniques
                                and learning procedures) that are behind the efficiency of solving systems (constraint solvers) for combinatorial
                                constrained problems. Two classical problems are considered for this competition:
                                <ul>
                                    <li> CSP (Constraint Satisfaction Problem)</li>
                                    <li> COP (Constrained Optimization Problem)</li>
                                </ul>
                            </div>
                            <div>
                                You can find the description of selected problems, submitted solvers as well as main tables of results concerning the
                                2022 competition in the <a href="https://www.cril.univ-artois.fr/~lecoutre/compets/proceedingsXCSP22.pdf" alt="proceedings">proceedings</a> (available soon).
                                On this website, you can get many detailed results (under the form of cactus plots, scatter plots, bar charts, tables) with respect to
                                the competition. Follow these links concerning the 6 tracks of the 2022 competition:


                                <div style={{width: "70%", margin: "20px auto", display:"grid", gridColumnGap : "70px",gridTemplateColumns : "1fr 1fr 1fr"}}>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/csp/csp"} variant="contained" color={"primary"}>CSP</Button>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/cop/fast-cop"} variant="contained" color={"primary"}>Fast COP</Button>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/csp/mini-csp"} variant="contained" color={"primary"}>Mini CSP</Button>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/cop/cop"} variant="contained" color={"primary"}>COP</Button>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/cop/parallel-cop"} variant="contained" color={"primary"}>// COP</Button>
                                    <Button component={Link} style={{margin : "10px"}} to={"competitions/cop/mini-cop"} variant="contained" color={"primary"}>Mini COP</Button>
                                </div>

                            </div>

                            <div>
                                <br />
                                For reproducing results, you can download:
                                <div style={{width: "40%", margin: "20px auto", display:"grid", gridColumnGap : "70px",gridTemplateColumns : "1fr 1fr"}}>
                                    <Button
                                        target="_blank"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        <a style={{color:"white", textDecoration:"none"}} href="https://www.cril.univ-artois.fr/~lecoutre/compets/instancesXCSP22.zip">
                                            Instances
                                        </a>
                                    </Button>

                                    <Button variant="contained" color="secondary">
                                        <a  style={{color:"white", textDecoration:"none"}} href={"https://www.cril.univ-artois.fr/~lecoutre/compets/modelsXCSP22.zip"}>Models</a>
                                    </Button>
                                </div>

                            </div>
                            <br /><br />
                            <div>
                                Information about the organization of the 2022 competition can be found in
                                this <a href="https://www.xcsp.org/competitions/" alt="web page about competitions">website </a>
                                and this <a href="https://www.cril.univ-artois.fr/~lecoutre/compets/callXCSP22.pdf" alt="call for solvers">call </a>.
                            </div>
                        </Typography>
                    </Box>
                    <Box pt={4}>
                        <Footer/>
                    </Box>
                </Container>
            </main>
        </div>

    )


}
